export default __webpack_public_path__ + "img/publication/publication1_480.webp";